import { useQuery } from '@mint-lib/query-client';
import { Auth } from '@mint-sdk/api-auth';

const useRolesData = () => {
  return useQuery({
    ...Auth.listAllRolesV2({ params: { limit: 0 } }),
    staleTime: Infinity,
  });
};

export default useRolesData;
